import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { heroNewImg, IncubationTabbing, investorTabbing } from 'src/assets/images';
import cx from "./ForInvestors.module.scss";
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import TopNavigation from '../topNavigation/TopNavigation';
import Footer from 'src/components/footer/footer';
import { useUrlParamValue } from 'src/hooks';
import { contactus } from 'src/store/auth/auth.slice';
import { useAppDispatch } from 'src/store/hooks';
import Form from 'react-bootstrap/Form';

const initialValue = {
    role: '',
    fullName: '',
    email: '',
    mobile: '',
    location: '',
    comments: 'new'
}
function ForInvestors() {
    const { paramValue } = useUrlParamValue();
    const location = useLocation()
    console.log(location, 'locationData');
    const url = `${location.pathname}${location.search}`

    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [change, setIsChange] = useState(false);
    const [show, setShow] = useState(false);
    const [hide, setHide] = useState<boolean>(false)
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [formData, setFormData] = useState(initialValue);
    const handleChange = (e: { target: { name: string, value: string } }) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        dispatch(contactus(formData)).then((res) => {
            if (res?.status === 200) {
                setShow(false)
                setFormData(initialValue)
            }
        }).catch((err) => {
            console.log(err);
            setHide(true)
            setTimeout(() => {
                setHide(false)
            }, 2000)
        })
    };
    console.log(hide, 'hideData');

    const type: string = paramValue({ paramName: 'type' }) as string;
    const firstHeading = type === 'investor' ? 'Empowering Investors to Discover, Connect, and Scale' : type === 'incubator' ? 'Empowering Incubators to Accelerate Impact' : 'Good things take time, great things are worth the wait! 🚀'
    const firstPara = type === 'investor'
        ? 'This is your gateway to groundbreaking ideas and ventures. Unlock curated investment opportunities and track your portfolio seamlessly, powered by AI-driven matchmaking.'
        : type === 'incubator' ? 'Join an Exclusive platform to streamline operations, nurture startups, and foster meaningful connections'
            : 'Our amazing team is working hard to bring you an incredible collection of resources to help you thrive in your entrepreneurial journey.'

    const secondHeading = type === 'investor' ? 'Exclusive Invite-Only Community' : 'Exclusive Invite-Only'
    const secondPara = type === 'investor'
        ? 'At htraction, we are curating an exclusive community of angel investors, HNIs, Ultra HNIs, and VCs focused on early-stage startups. Together, we are shaping the future of entrepreneurship by supporting transformative ideas and ventures.'
        : type === 'incubator' ? 'htraction is proud to collaborate with premier incubators shaping the entrepreneurial ecosystem. By joining, you will be part of an exclusive group driving innovation, mentoring startups, and fostering impactful collaborations.'
            : 'Sign up now to be the first to know when it is ready and unlock exclusive tools and insights along the way!'
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [type])
    return (
        <>
            <div>
                <TopNavigation change={change} />

                <section className={`${cx.forInvestSec}`}>
                    <Container>
                        <Row className='flex-wrap-reverse'>
                            <Col md={8}>
                                <div className={`${cx.content_main}`}>
                                    <h2>{firstHeading}</h2>
                                    <p>
                                        {firstPara}
                                    </p>

                                    {type !== 'resources' && <h2>{secondHeading}</h2>}
                                    <p>
                                        {secondPara}
                                    </p>
                                    <div className={`${cx.btnBox}`}>
                                        <NavLink to={type === 'resources' ? '/sign-up' : url} className={`btn`} onClick={handleShow}>{type === 'resources' ? 'Sign up' : 'Connect with us'}</NavLink>
                                    </div>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className={`${cx.img_box}`}>
                                    <img src={type === 'investor' ? investorTabbing : IncubationTabbing} alt={type} />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {type !== 'resources' && <section className={`${cx.video_testimonial}`}>
                    <Container>
                        <Row className='align-items-center'>
                            <Col md={5}>
                                <div className={`${cx.video_box}`}>
                                    <video controls>
                                        <source src="../../../assets/video/nature.mp4" type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            </Col>
                            <Col md={7}>
                                {type === 'investor' ? <div className={`${cx.content_box}`}>
                                    <h2>How it works?</h2>

                                    <ol>
                                        <li>
                                            <span>1. Request an Invite:</span> Fill out the form to join our exclusive investor community.
                                        </li>
                                        <li>
                                            <span>2. Get Curated Matches:</span> Our AI-powered platform connects you with high-potential
                                            startups tailored to your interests.
                                        </li>
                                        <li>
                                            <span>3. Track and Scale:</span> Manage and monitor your investments with end-to-end portfolio tools.
                                        </li>
                                    </ol>
                                </div> : (
                                    <div className={`${cx.content_box}`}>
                                        <h2>Why Join htraction?</h2>

                                        <ol>
                                            <li>
                                                <span>1. End-to-End Management:</span> Simplify program management with centralized tools for application, cohort tracking, and startup support.
                                            </li>
                                            <li>
                                                <span>2. Collaboration Hub:</span> Seamlessly connect with investors,mentors, and service providers to create an interconnected ecosystem.
                                            </li>
                                            <li>
                                                <span>3. AI Powered insights:</span> Leverage intelligent analytics to evaluate and mentor startups effectively.
                                            </li>
                                        </ol>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </section>}
                <Footer />
            </div>
            {show && !hide && (
                <div className={`${cx.contactBox}`} >
                    <Modal
                        show={show}
                        onHide={handleClose}
                        backdrop="static"
                        keyboard={false}
                        size="lg"
                        centered
                        className='contactPopup'
                    >
                        <Form onSubmit={handleSubmit}>
                            <Modal.Header closeButton className='contactModal'>
                                <Modal.Title>
                                    <h3>Reach out and <span>connect</span> with us.</h3>
                                    <p>Submit the form below to connect with us and join htraction as an incubator, accelerator, mentor, or investor.</p>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label>I am<span>*</span></label>
                                            <Form.Select
                                                aria-label="Default select example"
                                                name="role"
                                                value={formData.role}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">--Select--</option>
                                                <option value="Mentor">Mentor </option>
                                                <option value="Investor">Investor </option>
                                                <option value="Service Providers">Service Providers </option>
                                                <option value="Incubator">Incubator </option>
                                                <option value="Accelerator">Accelerator </option>
                                            </Form.Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label>Full Name*</label>
                                            <div className="form-input position-relative">
                                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 10.0625C5.88661 10.0625 4.0072 11.0829 2.81066 12.6665C2.55313 13.0073 2.42437 13.1777 2.42858 13.408C2.43184 13.586 2.54357 13.8104 2.68357 13.9203C2.86479 14.0625 3.11591 14.0625 3.61815 14.0625H12.3818C12.8841 14.0625 13.1352 14.0625 13.3164 13.9203C13.4564 13.8104 13.5682 13.586 13.5714 13.408C13.5756 13.1777 13.4469 13.0073 13.1893 12.6665C11.9928 11.0829 10.1134 10.0625 8 10.0625Z" stroke="#898989" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M8 8.0625C9.65685 8.0625 11 6.71935 11 5.0625C11 3.40565 9.65685 2.0625 8 2.0625C6.34314 2.0625 5 3.40565 5 5.0625C5 6.71935 6.34314 8.0625 8 8.0625Z" stroke="#898989" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    placeholder='Full Name'
                                                    name="fullName"
                                                    value={formData.fullName}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label>Email Address*</label>
                                            <div className="form-input position-relative">
                                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.3333 12.0625L9.90477 8.0625M6.09525 8.0625L1.6667 12.0625M1.33334 4.72917L6.77662 8.53947C7.2174 8.84801 7.43779 9.00229 7.67752 9.06204C7.88927 9.11483 8.11075 9.11483 8.3225 9.06204C8.56223 9.00229 8.78262 8.84801 9.2234 8.53947L14.6667 4.72917M4.53334 13.3958H11.4667C12.5868 13.3958 13.1468 13.3958 13.5747 13.1779C13.951 12.9861 14.2569 12.6801 14.4487 12.3038C14.6667 11.876 14.6667 11.3159 14.6667 10.1958V5.92917C14.6667 4.80907 14.6667 4.24901 14.4487 3.82119C14.2569 3.44487 13.951 3.13891 13.5747 2.94716C13.1468 2.72917 12.5868 2.72917 11.4667 2.72917H4.53334C3.41324 2.72917 2.85319 2.72917 2.42536 2.94716C2.04904 3.13891 1.74308 3.44487 1.55133 3.82119C1.33334 4.24901 1.33334 4.80907 1.33334 5.92917V10.1958C1.33334 11.3159 1.33334 11.876 1.55133 12.3038C1.74308 12.6801 2.04904 12.9861 2.42536 13.1779C2.85319 13.3958 3.41324 13.3958 4.53334 13.3958Z" stroke="#898989" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                <input
                                                    type="email"
                                                    className='form-control'
                                                    placeholder='Email Address'
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label>Contact number<span>*</span></label>
                                            <div className="form-input position-relative">
                                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.3333 12.0625L9.90477 8.0625M6.09525 8.0625L1.6667 12.0625M1.33334 4.72917L6.77662 8.53947C7.2174 8.84801 7.43779 9.00229 7.67752 9.06204C7.88927 9.11483 8.11075 9.11483 8.3225 9.06204C8.56223 9.00229 8.78262 8.84801 9.2234 8.53947L14.6667 4.72917M4.53334 13.3958H11.4667C12.5868 13.3958 13.1468 13.3958 13.5747 13.1779C13.951 12.9861 14.2569 12.6801 14.4487 12.3038C14.6667 11.876 14.6667 11.3159 14.6667 10.1958V5.92917C14.6667 4.80907 14.6667 4.24901 14.4487 3.82119C14.2569 3.44487 13.951 3.13891 13.5747 2.94716C13.1468 2.72917 12.5868 2.72917 11.4667 2.72917H4.53334C3.41324 2.72917 2.85319 2.72917 2.42536 2.94716C2.04904 3.13891 1.74308 3.44487 1.55133 3.82119C1.33334 4.24901 1.33334 4.80907 1.33334 5.92917V10.1958C1.33334 11.3159 1.33334 11.876 1.55133 12.3038C1.74308 12.6801 2.04904 12.9861 2.42536 13.1779C2.85319 13.3958 3.41324 13.3958 4.53334 13.3958Z" stroke="#898989" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    placeholder='Contact number'
                                                    name="mobile"
                                                    value={formData.mobile}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label>Location</label>
                                            <div className="form-input position-relative">
                                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clipPath="url(#clip0_2_128)">
                                                        <path d="M7.99999 8.72916C9.10456 8.72916 9.99999 7.83373 9.99999 6.72916C9.99999 5.62459 9.10456 4.72916 7.99999 4.72916C6.89542 4.72916 5.99999 5.62459 5.99999 6.72916C5.99999 7.83373 6.89542 8.72916 7.99999 8.72916Z" stroke="#898989" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M7.99999 14.7292C10.6667 12.0625 13.3333 9.67468 13.3333 6.72916C13.3333 3.78364 10.9455 1.39583 7.99999 1.39583C5.05447 1.39583 2.66666 3.78364 2.66666 6.72916C2.66666 9.67468 5.33332 12.0625 7.99999 14.7292Z" stroke="#898989" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_2_128">
                                                            <rect width="16" height="16" fill="white" transform="translate(0 0.0625)" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    placeholder='location'
                                                    name="location"
                                                    value={formData.location}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleClose}>
                                    Cancel
                                </Button>
                                <Button variant="primary" className='active' type="submit">
                                    Submit
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                </div>
            )}
        </>
    )
}

export default ForInvestors
